import React from 'react';
import { useTranslation } from 'react-i18next';
import { Item } from '@/types/item';
import Grid, { itemText } from '@/components/molecules/section/Grid';
import Container from '@/components/molecules/section/Container';

const View: React.FC<{ item: Item }> = ({ item }) => {
  const { t } = useTranslation();

  const { sellerShippingAddress } = item;

  const items = [
    itemText(t('item.shipping_from_adress.first_name'), sellerShippingAddress?.firstName),
    itemText(t('item.shipping_from_adress.surname'), sellerShippingAddress?.lastName),
    itemText(t('item.shipping_from_adress.address1'), sellerShippingAddress?.address1),
    itemText(t('item.shipping_from_adress.address2'), sellerShippingAddress?.address2),
    itemText(t('item.shipping_from_adress.district'), sellerShippingAddress?.district),
    itemText(t('item.shipping_from_adress.city'), sellerShippingAddress?.city),
    itemText(t('item.shipping_from_adress.province'), sellerShippingAddress?.province),
    itemText(t('item.shipping_from_adress.zip'), sellerShippingAddress?.zip),
    itemText(t('item.shipping_from_adress.country'), sellerShippingAddress?.country),
    itemText(t('item.shipping_from_adress.company_name'), sellerShippingAddress?.companyName),
    itemText(t('item.shipping_from_adress.phone_number'), sellerShippingAddress?.phoneNumber),
  ];

  return (
    <Container
      title={t('item.shipping_from_adress.title')}
      actions={[]}
      testId="shipping_from_adress"
    >
      <Grid
        column={5}
        items={items}
      />
    </Container>
  );
};

export default View;
